import { AnchorButton } from '@askable/ui/core/button';
import { DropdownMenuItem } from '@askable/ui/core/dropdown-menu';

import type { Notification } from '../types';

type NewFeaturesListProps = {
  notifications: Notification[];
  isMobile: boolean;
};

type NotificationListItemProps = {
  notification: Notification;
  isMobile: boolean;
};

const NotificationListItem = ({ notification, isMobile }: NotificationListItemProps) => {
  const content = (
    <div className="flex items-start gap-2" title={notification.title}>
      <div className="mt-1.5 size-1.5 shrink-0 rounded-full bg-chart-1" />
      <div className="line-clamp-3 flex-1 text-pretty font-semibold">{notification.title}</div>
    </div>
  );

  if (isMobile) {
    return notification.link ? (
      <AnchorButton
        variant="dropdown"
        width="full"
        href={notification.link}
        target="_blank"
        rel="noopener noreferrer"
        className="justify-start"
      >
        {content}
      </AnchorButton>
    ) : (
      <div className="flex items-center justify-start p-2">{content}</div>
    );
  }

  return notification.link ? (
    <DropdownMenuItem asChild>
      <a href={notification.link} target="_blank" rel="noopener noreferrer" className="flex items-center">
        {content}
      </a>
    </DropdownMenuItem>
  ) : (
    <DropdownMenuItem className="pointer-events-none flex items-center">{content}</DropdownMenuItem>
  );
};

export const NewFeaturesList = ({ notifications, isMobile }: NewFeaturesListProps) => {
  if (!notifications.length) {
    return null;
  }

  return (
    <>
      {notifications.map(notification => (
        <NotificationListItem key={notification._id} notification={notification} isMobile={isMobile} />
      ))}
    </>
  );
};
